import { Component, OnInit } from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import * as fromApp from '../../store/app.reducers';
import * as DemoActions from './../store/demo.actions';
import * as fromDemo from './../store/demo.reducers';
import * as fromProfile from '../../profile/store/profile.reducers';

@Component({
    selector: 'app-demo-list',
    templateUrl: './demo-list.component.html',
    styleUrls: ['./demo-list.component.scss'],
    standalone: false
})
export class DemoListComponent implements OnInit {

  demoState: Observable<fromDemo.State>;
  profileState: Observable<fromProfile.State>;

  constructor(
    private store: Store<fromApp.AppState>,

  ) { }

  ngOnInit() {
    this.store.dispatch(
      new DemoActions.GetDemoList(1)
    );
    this.demoState = this.store.select('demo');
    this.profileState = this.store.select('profile');
  }

}
